import moment from "moment";

export const parseApiDateToTimestamp = (date) => {
  if (!date) return 0;
  if (/^\d{2}-[A-Za-z]{3}-\d{2}$/.test(date)) {
    const [day, month, year] = date.split("-")
    const fullYear = `20${year}`; 

    const m = moment(
      `${day}-${month}-${fullYear}`,
      "DD-MMM-YYYY",
      true
    );

    return m.isValid() ? m.valueOf() : 0;
  }

  const m = moment(date);
  return m.isValid() ? m.valueOf() : 0;
};

export const formatApiDate = (date, format = "DD-MMM-YYYY") => {
  const ts = parseApiDateToTimestamp(date);
  return ts ? moment(ts).format(format) : "";
};
